type TImageProps = {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
  priority?: boolean;
  bgColor?: string;
  draggable?: boolean;
};

const CustomImage = ({
  src,
  alt,
  width,
  height,
  className,
  bgColor,
  draggable = false,
}: TImageProps) => {
  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={className}
      draggable={draggable}
      style={{
        width,
        height,
        maxWidth: width,
        maxHeight: height,
        minHeight: height,
        minWidth: width,
        ...(bgColor ? { background: `${bgColor}15` } : {}),
      }}
    />
  );
};

export default CustomImage;
